const DIMS = [
  { key: "technical", label: "Technical", sub: "verdict", hint: "How hard the bug is to exploit" },
  { key: "threat_maturity", label: "Threat maturity", sub: "level", hint: "Who is exploiting it" },
  { key: "environmental", label: "Exposure", sub: "level", hint: "Assumed from CVSS, default deployment" },
  { key: "patch_urgency", label: "Patch urgency", sub: "tier", hint: "Operational verdict" },
];

function tone(score) {
  if (score >= 8.5) return "text-red-700";
  if (score >= 6) return "text-orange-700";
  if (score >= 3) return "text-amber-700";
  return "text-slate-700";
}

export const ScoreDimensions = ({ dims, legacyScore }) => {
  if (!dims) return null;
  return (
    <div className="mb-5" data-testid="score-dimensions">
      <div className="overline mb-2 flex items-center justify-between">
        <span>Four separate measurements</span>
        {legacyScore != null && (
          <span
            data-testid="legacy-score"
            className="text-[10px] font-mono text-slate-500 normal-case tracking-normal"
          >
            legacy single score {Number(legacyScore).toFixed(1)}/10
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {DIMS.map(({ key, label, sub, hint }) => {
          const d = dims[key];
          if (!d) return null;
          const s = Number(d.score ?? 0);
          return (
            <div
              key={key}
              data-testid={`dimension-${key}`}
              className="bg-slate-50 border border-slate-200 rounded-md p-3 transition-colors duration-200 hover:border-violet-300"
              title={(d.drivers || []).join("\n")}
            >
              <div className="overline">{label}</div>
              <div className={`font-mono font-bold text-xl mt-1 ${tone(s)}`}>
                {s.toFixed(1)}
                <span className="text-slate-500 text-xs ml-0.5">/10</span>
              </div>
              <div className="text-[11px] text-slate-900 font-mono mt-0.5 break-words">{d[sub] || "-"}</div>
              <div className="text-[10px] text-slate-500 mt-0.5">{hint}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
